import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { AsyncImportStatus, Info } from "../../models/domains/pbm/async-import/async-import-status";
import { BackendUrl } from "../../models/domains/urls/back-end.url";

@Injectable({ providedIn: "root" })
export class AsyncImportRepository {
    constructor(private gatewayFactory: RemoteGatewayFactory) { }

    async checkStatus(key: string): Promise<AsyncImportStatus> {
        try {
            const gateway = this.gatewayFactory.createDefaultRemoteGateway();
            const respose = await gateway.get(new BackendUrl(`/api/import/check/${key}`)) as {
                Status: string,
                Description: string,
                Created: string,
                StartedAt: string,
                FinishAt: string,
                Info: {
                    TotalUpdated: number,
                    TotalCreated: number,
                    TotalRemoved: number,
                    TotalFailed: number,
                    ExceptionLog: string,
                    InfoLog:boolean
                } | null
            };
            const asyncStatus = new AsyncImportStatus(respose.Status, respose.Description,
                respose.Info ? new Info(respose.Info.TotalUpdated,
                    respose.Info.TotalCreated,
                    respose.Info.TotalRemoved,
                    respose.Info.TotalFailed,
                    respose.Info.ExceptionLog, 
                    respose.Info.InfoLog) : null);

            asyncStatus.createdAt = respose.Created
            asyncStatus.startedAt = respose.StartedAt,
            asyncStatus.finishAt = respose.FinishAt
            return asyncStatus
        } catch (err) {
            return await Promise.reject(err);
        }
    }

    async fileSummary(key: string): Promise<any> {

        try {
            const headers = { "Content-Type": "application/json" };
            const gateway = this.gatewayFactory.createDefaultRemoteGateway();
            return await gateway.downloadAsGet(new BackendUrl(`/api/import/summary/${key}/file`), headers);
        } catch (error) {
            return await Promise.reject(error);
        }
    }
}